module.exports = __webpack_public_path__ + "img/exit.a13980e9.svg";